(function() {

	$(document).ready(() => {
		$('.project-cards__wrap').flickity({
			wrapAround: true,
			watchCSS: true,
			prevNextButtons: false,
			pageDots: false
		});
	});

})();